/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowcoverdone3Inputs */

const en_aiflowcoverdone3 = /** @type {(inputs: Aiflowcoverdone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done. Your design in every chosen format, all in the same look. Everything is in your media library too.`)
};

const de_aiflowcoverdone3 = /** @type {(inputs: Aiflowcoverdone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fertig. Dein Design in jedem gewählten Format, alle im gleichen Look. Alles liegt auch in deiner Mediathek.`)
};

/**
* | output |
* | --- |
* | "Done. Your design in every chosen format, all in the same look. Everything is in your media library too." |
*
* @param {Aiflowcoverdone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowcoverdone3 = /** @type {((inputs?: Aiflowcoverdone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowcoverdone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowcoverdone3(inputs)
	return de_aiflowcoverdone3(inputs)
});
export { aiflowcoverdone3 as "aiFlowCoverDone" }